<template>
    <page-table />
</template>
<script>
import PageTable from './components/table/index.vue'

export default {
    name: 'system-merchantFunctionFormLanguage',
    components: {
        PageTable,
    },
}
</script>